import request from '/utils/request';

// 底部接口调用
export function searchBottomField() {
  return request({
    url: '/finance/Reception/bottomDisplay',
    method: 'get',
  });
}
